import { render, staticRenderFns } from "./InstructorSettings.vue?vue&type=template&id=4d085d51"
import script from "./InstructorSettings.vue?vue&type=script&lang=ts"
export * from "./InstructorSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports